module.exports = __webpack_public_path__ + "img/morocco.9b46ab7.webp";